'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _usersFilter = require('./users-filter.html');

var _usersFilter2 = _interopRequireDefault(_usersFilter);

var _usersFilter3 = require('./users-filter.controller');

var _usersFilter4 = _interopRequireDefault(_usersFilter3);

require('./users-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _usersFilter2.default,
  controller: _usersFilter4.default,
  controllerAs: 'vm'
};

exports.default = usersFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/users-filter/users-filter.component.js
 **/